import React from 'react';
import { useMessageGetter } from 'react-message-context';
import styled from 'styled-components/macro';
import { CalendarIcon, LocationIcon } from '../../../assets';
import { useFormattedClockTime } from '../../../hooks';
import { formatDateTimeFromString } from '../../../utils';
import { Bold, H2, H5, TextBlock } from '../Text';
import { PreviewContentBlock, Row } from '../layoutComponents';
import { EventInviteFormState } from './schema';
import { EventType } from '../../../types/events';

const PreviewContent = styled(PreviewContentBlock)``;
const EventDetails = styled(PreviewContentBlock)`
  gap: 16px;
`;
const EventDescription = styled(PreviewContentBlock)`
  gap: 10px;
`;

type Props = { formData: EventInviteFormState };

export const EventInvitePreview = ({ formData }: Props): React.ReactElement => {
  const t = useMessageGetter('forms.eventInvite');
  const { formatClockTime } = useFormattedClockTime();

  const formattedDate = formData.date ? formatDateTimeFromString(formData.date, true) : '';

  const isCommunityMeeting = formData.eventType === EventType.CommunityMeeting;
  const titleText = isCommunityMeeting ? `${t('communityMeeting')}: ${formData.name}` : formData.name;

  return (
    <PreviewContent>
      <H2>{titleText}</H2>
      <EventDetails>
        <Row>
          <CalendarIcon />{' '}
          <Bold>
            {formattedDate} {formatClockTime(formData.time)}
          </Bold>
        </Row>
        <Row>
          <LocationIcon />
          <Bold>
            {formData.property} {isCommunityMeeting && ` - ${formData.location}`}
          </Bold>
        </Row>
      </EventDetails>
      {isCommunityMeeting && <H5>{t('agenda')}</H5>}
      <EventDescription>
        <TextBlock>{formData.description}</TextBlock>
        {isCommunityMeeting && <TextBlock style={{ marginTop: '40px' }}>{formData.regards}</TextBlock>}
      </EventDescription>
    </PreviewContent>
  );
};
